import { render, staticRenderFns } from "./SearchFor.vue?vue&type=template&id=2727597e&scoped=true&"
import script from "./SearchFor.vue?vue&type=script&lang=js&"
export * from "./SearchFor.vue?vue&type=script&lang=js&"
import style0 from "./SearchFor.vue?vue&type=style&index=0&id=2727597e&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2727597e",
  null
  
)

export default component.exports